import React, { useState } from 'react';
import { Form, Image, Placeholder } from 'semantic-ui-react';
import { FormFieldProps } from 'semantic-ui-react/dist/commonjs/collections/Form/FormField';

import { useAppDispatch } from 'src/store';
import { uploadImage } from 'src/thunks/fileUpload';
import { UPLOAD_MODULE } from 'src/constants/app';
import default_img from 'src/assets/default_profile.jpeg';

export type Props = {
  value?: string;
  onChange?: (e: any, data: any) => void;
  name: string;
  module?: string;
  label?: string;
  buttonTxt?: string;
  center?: boolean;
  defaultImg?: string;
} & FormFieldProps;

const UploadField: React.FC<Props> = ({
  id = 'upload',
  value,
  onChange,
  name,
  module = UPLOAD_MODULE.OTHERS,
  label,
  buttonTxt = 'Replace profile image',
  center,
  defaultImg,
  ...rest
}) => {
  const dispatch = useAppDispatch();
  const [src, setSrc] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);

  const onChangeFile = async (file?: File) => {
    if (!file) return;

    setLoading(true);

    const res = await dispatch(uploadImage({ images: [file] }));

    // @ts-ignore
    const url = res.payload.data[0]?.access_url;

    setSrc(url);
    onChange?.({ target: { value: url, name } }, { value: url });

    setLoading(false);
  };

  return (
    <Form.Field {...rest} className={`upload_field`}>
      <label htmlFor={String(name)} className={center ? 'margin-center' : ''}>
        {label}
        {loading ? (
          <Placeholder
            style={{ height: 120, width: 120, borderRadius: '50%' }}
            className="margin-center"
          >
            <Placeholder.Image />
          </Placeholder>
        ) : (
          <Image
            src={src || value || defaultImg || default_img}
            width={120}
            height={120}
            alt=""
            circular
            centered
            className="object-fit-cover cursor-pointer"
          />
        )}
        <span className="ui basic primary button cursor-pointer my-12">
          {buttonTxt}
        </span>
      </label>
      <input
        type="file"
        className="d-none"
        id={String(name)}
        accept="image/*"
        onChange={(e) => onChangeFile(e.target.files?.[0])}
      />
    </Form.Field>
  );
};

export default UploadField;
